export default function PersonShape() {
  return (
    <svg width='24.963' height='40' viewBox='0 0 24.963 40'>
      <path d='M17.708,12.794a7.263,7.263,0,0,0,2.262-5.3,7.2,7.2,0,0,0-2.223-5.266A7.2,7.2,0,0,0,12.482,0,7.2,7.2,0,0,0,7.216,2.223,7.2,7.2,0,0,0,4.993,7.489a7.2,7.2,0,0,0,2.223,5.266,7.2,7.2,0,0,0,5.266,2.223A7.132,7.132,0,0,0,17.708,12.794Zm3.51,9.361q-3.745-4.681-8.737-4.681T3.745,22.155A17.309,17.309,0,0,0,0,33.311a4.553,4.553,0,0,0,1.365,3.276,8.765,8.765,0,0,0,3.588,2.145,26.342,26.342,0,0,0,4.876,1.092,20.128,20.128,0,0,0,5.3,0,26.342,26.342,0,0,0,4.876-1.092A8.765,8.765,0,0,0,23.6,36.587a4.553,4.553,0,0,0,1.365-3.276A17.309,17.309,0,0,0,21.219,22.155Z' />
    </svg>
  )
}
